import {getTextScripts} from "@/actions/scripts/actions";
import {useOrg} from "@/hooks/useOrg";
import {createSharedApprovalLookup} from "./createSharedApprovalLookup";

const NO_NAMES: ReadonlyMap<string, string> = new Map();
const useNames = createSharedApprovalLookup(async (_orgId: string) => {
   const scripts = await getTextScripts();
   return new Map(scripts.filter(script => script.name?.trim()).map(script => [script.id.toLowerCase(), script.name]));
});

/** Text script names by ID for display. An unknown ID stays unresolved, never guessed. */
export function useTextScriptNames(enabled: boolean): ReadonlyMap<string, string> {
   const {org} = useOrg();
   return useNames(enabled && org?.id ? org.id : null) ?? NO_NAMES;
}
